// :cow: Cosmose CONFIDENTIAL :iso:
import { Directive, Input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { take } from 'rxjs/operators';
import { FeatureToggle } from '@coa/app/shared/feature-toggle/models/feature.toggle';
import { FeatureToggleService } from '@coa/app/shared/feature-toggle/services/feature-toggle.service';

@Directive({
  selector: '[coaFeatureToggleDisable]',
})
export class FeatureToggleDisableDirective implements OnChanges {
  @Input() coaFeatureToggleDisable: FeatureToggle;
  @Input() coaFeatureToggleDisableClientId: string;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private featureToggleService: FeatureToggleService,
  ) {
  }

  ngOnChanges(): void {
    this.viewContainer.clear();
    if (!this.coaFeatureToggleDisable) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
    if (this.coaFeatureToggleDisable) {
      this.featureToggleService.isFeatureAdded(this.coaFeatureToggleDisable, this.coaFeatureToggleDisableClientId)
        .pipe(take(1))
        .subscribe((isDisabled) => {
          if (!isDisabled) {
            this.viewContainer.createEmbeddedView(this.templateRef);
          }
        });
    }
  }

}
